import React from "react";
import styles from "./UpgradeToPro.module.sass";
import Packages from "./Packages";
import Faq from "./Faq";

const UpgradeToPro = () => {
	return (
		<>
			<Packages className={styles.packages} />
			<Faq />
		</>
	);
};

export default UpgradeToPro;
